
import React from "react";

const STATUS_CONFIG = {
  active: {
    label: "Active",
    className: "bg-emerald-50 text-emerald-700 ring-1 ring-inset ring-emerald-600/20",
    dotClassName: "bg-emerald-500",
  },
  inactive: {
    label: "Inactive",
    className: "bg-gray-100 text-gray-600 ring-1 ring-inset ring-gray-500/20",
    dotClassName: "bg-gray-400",
  },
  draft: {
    label: "Draft",
    className: "bg-amber-50 text-amber-700 ring-1 ring-inset ring-amber-600/20",
    dotClassName: "bg-amber-500",
  },
  published: {
    label: "Published",
    className: "bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-600/20",
    dotClassName: "bg-blue-500",
  },
  archived: {
    label: "Archived",
    className: "bg-gray-100 text-gray-600 ring-1 ring-inset ring-gray-500/20",
    dotClassName: "bg-gray-400",
  },
};

const GroupStatusBadge = ({
  isActive,
  status,
  showDot = true,
  size = "md",
  className = "",
}) => {
  /*
   * English question groups normally use `isActive`.
   * If a string status is provided, prefer it.
   */
  let normalizedStatus;

  if (status !== undefined && status !== null) {
    normalizedStatus = String(status).trim().toLowerCase();
  } else {
    normalizedStatus = isActive ? "active" : "inactive";
  }

  const config =
    STATUS_CONFIG[normalizedStatus] ||
    STATUS_CONFIG.inactive;

  const sizeClasses = {
    sm: {
      badge: "px-2 py-0.5 text-[10px]",
      dot: "h-1.5 w-1.5",
    },
    md: {
      badge: "px-2.5 py-1 text-xs",
      dot: "h-2 w-2",
    },
    lg: {
      badge: "px-3 py-1.5 text-sm",
      dot: "h-2.5 w-2.5",
    },
  };

  const selectedSize =
    sizeClasses[size] || sizeClasses.md;

  return (
    <span
      className={[
        "inline-flex items-center gap-1.5 rounded-full font-semibold",
        selectedSize.badge,
        config.className,
        className,
      ].join(" ")}
    >
      {showDot && (
        <span
          className={[
            "rounded-full",
            selectedSize.dot,
            config.dotClassName,
          ].join(" ")}
          aria-hidden="true"
        />
      )}

      <span>{config.label}</span>
    </span>
  );
};

export default GroupStatusBadge;

